export default "<div class=\"footer\">\r\n <app-notification></app-notification>\r\n</div>\r\n";